import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("humadash_user");
    return saved ? JSON.parse(saved) : null;
  });
  const [loading] = useState(false);
  const [error, setError] = useState(null);

  const login = async (email, password) => {
    setError(null);
    // Simulated login — accept any credentials
    const mockUser = {
      id: "user-demo",
      name: email.split("@")[0] || "Demo User",
      email,
      role: "donor",
    };
    localStorage.setItem("humadash_token", "mock-jwt-token");
    localStorage.setItem("humadash_user", JSON.stringify(mockUser));
    setUser(mockUser);
    return mockUser;
  };

  const register = async (userData) => {
    setError(null);
    const mockUser = {
      id: "user-" + Date.now(),
      name: userData.name || userData.username || "New User",
      email: userData.email,
      role: userData.role || "donor",
    };
    localStorage.setItem("humadash_token", "mock-jwt-token");
    localStorage.setItem("humadash_user", JSON.stringify(mockUser));
    setUser(mockUser);
    return mockUser;
  };

  const logout = () => {
    localStorage.removeItem("humadash_token");
    localStorage.removeItem("humadash_user");
    setUser(null);
  };

  const value = {
    user,
    loading,
    error,
    login,
    register,
    logout,
    isAuthenticated: !!user,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
